module.exports = __webpack_public_path__ + "static/media/remove-from-list.189bf546.svg";